module.exports = __webpack_public_path__ + "static/media/cancel_btn_default.77fde942.svg";